import commonTableColumns from '@root/components/table/commonTableColumns';
import { VulnerabilityCounts } from '../VulnerabilityCounts';
import DateFormatPipe from '@root/components/utilities/DateFormatPipe';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import Text from '@root/components/v2/ui-elements/Text';
import { Box } from '@mui/material';
import { CommonToggleSwitch } from '@root/utilities/common';

export const k8workloadColumns = (isFetchingTagCrownJewel, handleTagCrownJewel) => [
  commonTableColumns.environment('account_id', 'cluster'),
  {
    field: 'namespace',
    headerName: 'Namespace',
    width: 200,
    renderCell: params => {
      return (
        <Tooltip title={params.row.namespace}>
          <Text className="m-0 SingleLine">{params.row.namespace}</Text>
        </Tooltip>
      );
    },
  },

  {
    field: 'workload',
    headerName: 'Workload ',
    width: 200,
    renderCell: params => {
      return (
        <Box display={'flex'} flexDirection={'column'} gap={'4px'} width={'100%'}>
          <Tooltip title={params?.row?.workload_name ?? '-'}>
            <Text className="m-0 SingleLine">{params?.row?.workload_name ?? '-'}</Text>
          </Tooltip>
          <Tooltip title={params.row.workload_kind}>
            <Text className="m-0 SingleLine">{params?.row?.workload_kind ?? '-'}</Text>
          </Tooltip>
        </Box>
      );
    },
  },
  {
    field: 'crown_toogle',
    headerName: 'Crown',
    width: 50,
    renderCell: params => {
      // Prevent row click propagation by handling both onClick and onChange
      const handleClick = e => e.stopPropagation();
      const handleChange = e => {
        handleTagCrownJewel(params.row, e.target.checked);
      };
      return (
        <Tooltip title={params.row.is_crown_jewel ? 'Untag Workload' : 'Tag Workload'} isIcon={true}>
          <span
            data-testid="click-k8s-pages-workload-workloadcolumns-handleclick-54"
            data-clickable="true"
            onClick={handleClick}>
            <CommonToggleSwitch
              icon={
                <>
                  <img src="/images/visualizer/tools/crown-icon-grey.svg" />
                </>
              }
              checkedIcon={
                <>
                  <img src="/images/visualizer/tools/crown-icon-purple.svg" />
                </>
              }
              disabled={isFetchingTagCrownJewel}
              checked={params.row.is_crown_jewel}
              onChange={handleChange}
            />
          </span>
        </Tooltip>
      );
    },
  },

  {
    field: 'vulnerabilities',
    headerName: 'Vulnerabilities',
    width: 300,
    renderCell: params => {
      return params?.row?.vulnerability_counts ? (
        <VulnerabilityCounts vulnerabilities={params.row.vulnerability_counts} />
      ) : (
        '-'
      );
    },
  },
  {
    field: 'image_count',
    headerName: 'Image',
    renderCell: params => {
      return params.row?.image_count ?? '-';
    },
    width: 100,
  },
  {
    field: 'status',
    headerName: 'State',
    width: 100,
  },
  {
    field: 'last_scan',
    headerName: 'Last Scan',
    renderCell: parmas => {
      return DateFormatPipe(parmas.row.last_scan);
    },
    width: 230,
  },
];
